/**
 * 運営プリセット (リポジトリ同梱 JSON・docs/features/banner-layout-template-plan.md §6)。
 * 要素は文言を持たない (文言は「テキスト」アコーディオンの欄・§13)。商品枠は「選択中の画像の何枚目か」を指す (§17)。
 */
import presetsJson from './presets.json';
import { ratiosMatch } from './effectiveAspectRatio';
import { cloneLayoutWithNewIds } from './geometry';
import { toIndexedProducts, type LayoutImage } from './productImages';
import type { BannerLayout, BannerLayoutBackground, BannerLayoutElement } from './types';

export type BannerLayoutPresetEntry = {
  id: string;
  name: string;
  aspectRatio: string;
  tags: string[];
  /** product 要素は「選択中の画像の何枚目か」(imageIndex・既定0) を指す */
  layout: { version: 1; aspectRatio: string; elements: BannerLayoutElement[]; background?: BannerLayoutBackground };
};

export const BANNER_LAYOUT_PRESETS = (presetsJson as unknown as { presets: BannerLayoutPresetEntry[] }).presets;

/** 現在の比率に合うものを先に並べる (他の比率も選べる) */
export function sortPresetsForRatio(presets: BannerLayoutPresetEntry[], aspect: string): BannerLayoutPresetEntry[] {
  const match = presets.filter((p) => ratiosMatch(p.aspectRatio, aspect));
  const rest = presets.filter((p) => !ratiosMatch(p.aspectRatio, aspect));
  return [...match, ...rest];
}

/**
 * プリセット / テンプレートをキャンバスへ複製する (id を振り直す・元は変えない)。
 * 商品枠は「選択中の画像の何枚目か」を指すので、素材が無くても残す (§17)。旧データの assetId は選択中の画像の位置に置き換える。
 */
export function instantiateLayout(
  source: { aspectRatio: string; elements: BannerLayoutElement[]; background?: BannerLayoutBackground },
  aspectRatio: string,
  images: LayoutImage[] = [],
): BannerLayout {
  const cloned = cloneLayoutWithNewIds(
    { version: 1, aspectRatio: source.aspectRatio, elements: source.elements, ...(source.background ? { background: source.background } : {}) },
    aspectRatio,
  );
  return { ...cloned, elements: toIndexedProducts(cloned.elements, images) };
}
